export default __webpack_public_path__ + "static/media/TubeMechanicsImg.7d9a76dc.jpg";